import Fab from '@material-ui/core/Fab';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import { history, useIntl } from 'umi';
import VerticalAlignCenterOutlinedIcon from '@material-ui/icons/VerticalAlignCenterOutlined';
import ActionButtonGroupStyled from './ActionButtonGroupStyled';
import { createOid } from '@/utils/eventtracing';

const ActionBtnGroup = () => {
  //国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const handleClickMany = () => {
    history.push({
      pathname: '/adjust/adjust_list/adjust_many',
      query: {
        tab: 1,
      },
    });
  };

  //  卡号合并跳转
  const handleCardMerge = () => {
    history.push({
      pathname: '/adjust/adjust_list/card_merge',
    });
  };

  return (
    <ActionButtonGroupStyled>
      <div className="export-wrapper">
        <Fab
          data-log={JSON.stringify({
            oid: createOid('ec'),
            events: ['_ev', '_ec'],
            params: {
              initUrl: window.location.origin + window.location.pathname,
            },
          })}
          variant="extended"
          size="small"
          color="primary"
          aria-label="add"
          className="export"
          sx={{ marginRight: '16px' }}
          onClick={handleClickMany}
        >
          <PlaylistAddCheckIcon sx={{ width: '21px', height: '14px' }} />
          {formatMessage({ id: 'adjustment.members.n02.btn01' })}
        </Fab>
        <Fab
          data-log={JSON.stringify({
            oid: createOid('ec'),
            events: ['_ev', '_ec'],
            params: {
              initUrl: window.location.origin + window.location.pathname,
            },
          })}
          variant="extended"
          size="small"
          color="primary"
          aria-label="add"
          className="export"
          onClick={handleCardMerge}
        >
          <VerticalAlignCenterOutlinedIcon
            sx={{ width: '16px', height: '22px' }}
          />
          {formatMessage({ id: 'adjustment.members.merge.menu' })}
        </Fab>
      </div>
    </ActionButtonGroupStyled>
  );
};
export default ActionBtnGroup;
